<template>
	<div class="relative">
		<label :for="id" class="sr-only">{{
			$t('email-templates.search')
		}}</label>
		<IconMagnifyingGlass
			size="16"
			class="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-grey-500"
		/>
		<input
			:id="id"
			type="search"
			:value="value"
			:placeholder="placeholder || $t('email-templates.search')"
			class="h-10 w-full rounded-lg border border-grey-300 pl-10 pr-3 text-sm text-grey-1000 placeholder:text-grey-500 focus-visible:ring-2 focus-visible:ring-grey-500"
			@input="$emit('input', $event.target.value)"
		/>
	</div>
</template>
<script>
import IconMagnifyingGlass from '~/components/Icons/IconMagnifyingGlass'
export default {
	components: { IconMagnifyingGlass },
	props: {
		placeholder: String,
		value: { type: String, default: '' },
		id: { type: String, default: 'template-search' }
	}
}
</script>
